import brandingLogo from "assets/logoSuitPods.png";
import { Container } from "./styles";

const Header = () => {
  return (
    <Container>
      <img src={brandingLogo} alt="Suit Delivery" />
    </Container>
  );
};

export default Header;
